<template>
  <svg
    class="svg-icon"
    :style="{
      width: svgWidth,
      height: svgHeight,
      color: color,
    }"
  >
    <use :xlink:href="`#icon-${name}`" :fill="color" :stroke="color" />
  </svg>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'SvgIcon',
  props: {
    name: {
      type: String,
      required: true,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '',
    },
    widht: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '#000',
    },
  },
  setup(props) {
    const svgWidth = computed(() => {
      if (props.size) return props.size + 'px'
      if (props.widht) return props.widht + 'px'
      return 'auto'
    })
    const svgHeight = computed(() => {
      if (props.size) return props.size + 'px'
      if (props.height) return props.height + 'px'
      return 'auto'
    })
    return {
      svgWidth,
      svgHeight,
    }
  },
})
</script>
